import axios from 'axios';
import * as actions from 'redux/actions/api/unregister';

const BASE_URL = process.env.REACT_APP_ANDROMEDA_UNREGISTER_BASEURL;

const CLEANUP_STATUS = {
  STAY_IN_NETWORK: 1,
  REQUESTED_DELETION: 2,
};

export const deletePartner = (personId) => (dispatch) => {
  dispatch(actions.unregisterDeleteRequest());

  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  axios
    .post(`${BASE_URL}/Partner/PartnerCleanupResponse`, {
      personId: personId,
      cleanupStatus: CLEANUP_STATUS.REQUESTED_DELETION,
    }, { headers })
    .then((response) => {
      if (response.data === true) {
        dispatch(actions.unregisterDeleteSuccess(response.data));
      } else {
        dispatch(actions.unregisterDeleteFailure({ response: { data: { message: 'Could not process your request. Please contact PartnerBusinessSupport@afry.com.' } } }));
      }
    })
    .catch((error) => {
      dispatch(actions.unregisterDeleteFailure(error));
    });
};

export const remainPartner = (personId) => (dispatch) => {
  dispatch(actions.unregisterRemainRequest());

  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  axios
    .post(`${BASE_URL}/Partner/PartnerCleanupResponse`, {
      personId: personId,
      cleanupStatus: CLEANUP_STATUS.STAY_IN_NETWORK,
    }, { headers })
    .then((response) => {
      if (response.data === true) {
        dispatch(actions.unregisterRemainSuccess(response.data));
      } else {
        dispatch(actions.unregisterRemainFailure({ response: { data: { message: 'Could not process your request. Please contact PartnerBusinessSupport@afry.com.' } } }));
      }
    })
    .catch((error) => {
      dispatch(actions.unregisterRemainFailure(error));
    });
};